import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { GroupSvg } from './Group';

export const GroupIcon = createIcon('group', GroupSvg);
/**
 * @deprecated используйте GroupIcon
 */
export const withGroupIcon = withIcon('group', GroupSvg);
